module.exports = __webpack_public_path__ + "img/deu.3e726c2b.svg";